import {
  Box,
  Button,
  Dialog,
  formatPhoneNumberForDisplay,
  OTPInputField,
  Typography,
} from "@luce/ui";

import { formatCountdown, OTP_LENGTH } from "../../account-info/lib";
import { useChangePhoneNumberContext } from "../change-phone-number-context";

export function ChangePhoneNumberOtpModal() {
  const {
    step,
    newPhoneNumber,
    pinCode,
    otpError,
    remaining,
    isConfirmingOtp,
    setPinCode,
    confirmOtp,
    requestCancel,
  } = useChangePhoneNumberContext();

  const handleOpenChange = (next: boolean) => {
    if (!next) requestCancel();
  };

  return (
    <Dialog.Root open={step === "otp"} onOpenChange={handleOpenChange} size="sm">
      <Dialog.Header>
        <Dialog.Title>OTP Verification</Dialog.Title>
        <Dialog.Description>
          {`A verification code has been sent to ${formatPhoneNumberForDisplay(newPhoneNumber)}`}
        </Dialog.Description>
      </Dialog.Header>

      <Dialog.Body>
        <Box className="gap-spacing-md flex flex-col items-center">
          <OTPInputField
            length={OTP_LENGTH}
            value={pinCode}
            onChange={setPinCode}
            size="sm"
            gap="compact"
            state={otpError ? "error" : "default"}
          />
          {otpError ? (
            <Typography variant="body-sm" color="system-danger-default" align="center">
              {otpError}
            </Typography>
          ) : null}
          <Typography variant="body-sm" color="neutral-foreground-intermediate" align="center">
            {`Remaining time: ${formatCountdown(remaining)}`}
          </Typography>
        </Box>
      </Dialog.Body>

      <Dialog.Footer layout="stacked">
        <Button
          size="lg"
          fullWidth
          label="Continue"
          loading={isConfirmingOtp}
          disabled={remaining === 0 || pinCode.length !== OTP_LENGTH}
          onClick={confirmOtp}
        />
        <Button
          variant="secondary"
          size="lg"
          fullWidth
          label="Cancel"
          disabled={isConfirmingOtp}
          onClick={requestCancel}
        />
      </Dialog.Footer>
    </Dialog.Root>
  );
}
